import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconWarningNewSvg } from "./IconWarningNewSvg.mjs";
const IconWarningNew = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconWarningNewSvg, ...iconProps });
};
export {
  IconWarningNew
};
